export const serverUrl = process.env.REACT_APP_USE_LOCAL_SERVER
  ? process.env.REACT_APP_LOCAL_SERVER_URL
  : process.env.REACT_APP_SERVER_ENDPOINT;
